module.exports = __webpack_public_path__ + "static/media/icon-supplies-nailclippers.834c59c3.svg";